import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Signatures } from '../models/signatures.model';
import { environment } from '@environment';
import { CommunityUser } from '@sb-tools/typescript/models/community-user.model';
import { serializeToString } from '@sb-tools/typescript/helpers/serialize';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { SimpleCommunityWithOpenTicketsCount } from '@sb-tools/typescript/models/simple-community-with-open-tickets-count.model';
import { CommunityUserExtended } from '@sb-tools/typescript/models/community-user-extended.model';
import { BaseUserDTO } from '@sb-tools/typescript/models/dto/base-user.dto';
import { UserGroupDTO } from '@sb-tools/typescript/models/dto/user-group.dto';

@Injectable({ providedIn: 'root' })
export class UserDataService {
    constructor(private httpClient: HttpClient) {}

    get(userId: string): Observable<BaseUserWithRole> {
        return this.httpClient.get<BaseUserWithRole>(environment.apiInboxUrl + 'users/' + userId);
    }

    getAll(includeVendors = true, keyWords?: string): Observable<BaseUserWithRole[]> {
        return this.httpClient.get<BaseUserWithRole[]>(
            environment.apiInboxUrl +
                'admin/users/communityMembers?includeVendors=' +
                includeVendors +
                '&keyword=' +
                keyWords,
        );
    }

    getCommunities(): Observable<SimpleCommunityWithOpenTicketsCount[]> {
        return this.httpClient.get<SimpleCommunityWithOpenTicketsCount[]>(
            environment.apiInboxUrl + 'communities/available/',
        );
    }

    getCurrentUser(): Observable<CommunityUserExtended> {
        return this.httpClient.get<CommunityUserExtended>(environment.apiInboxUrl + 'users/FullUserInfo');
    }

    getShortUserInfo(): Observable<BaseUserDTO> {
        return this.httpClient.get<BaseUserDTO>(environment.apiInboxUrl + 'users/shortUserInfo');
    }

    getSignatures(): Observable<Signatures> {
        return this.httpClient.get<Signatures>(environment.apiInboxUrl + 'users/Signatures');
    }

    getUserGroups(): Observable<UserGroupDTO[]> {
        return this.httpClient.get<UserGroupDTO[]>(environment.apiInboxUrl + 'UserGroups');
    }

    getUsersByIds(data: { userIds: string[] }): Observable<CommunityUser[]> {
        const filteredData = Object.fromEntries(
            Object.entries(data).filter(
                ([, value]) => value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0),
            ),
        );
        const queryParams = serializeToString(filteredData);

        return this.httpClient.get<CommunityUser[]>(environment.apiMasterUrl + 'users/byids?', { params: queryParams });
    }

    getUsersToAssign(categoryId: number = null): Observable<BaseUserWithRole[]> {
        return this.httpClient.get<BaseUserWithRole[]>(
            environment.apiInboxUrl + 'outlook/usersToAssign?categoryId=' + categoryId,
        );
    }

    getVendors(): Observable<BaseUserWithRole[]> {
        return this.httpClient.get<BaseUserWithRole[]>(environment.apiInboxUrl + 'users/Vendors/');
    }

    updateChatSendingByEnter(userId: string, isChatSendingByEnter: boolean): Observable<void> {
        return this.httpClient.patch<void>(
            environment.apiMasterUrl +
                'admin/users/' +
                userId +
                '/chatSendingByEnter?isChatSendingByEnter=' +
                isChatSendingByEnter,
            null,
        );
    }
}
